import { rootShouldForwardProp, styled } from '../styled';
var imageComponentName = 'QuantumImage';
export var imageFit = {
    contain: 'contain',
    cover: 'cover',
    none: 'unset',
    'scale-down': 'scale-down',
};
export var Image = styled('img', {
    name: imageComponentName,
    shouldForwardProp: function (prop) {
        return rootShouldForwardProp(prop) &&
            prop !== 'fit' &&
            prop !== 'disableResponsive' &&
            prop !== 'height' &&
            prop !== 'width';
    },
})(function (_a) {
    var height = _a.height, width = _a.width, fit = _a.fit, disableResponsive = _a.disableResponsive;
    return ({
        display: 'block',
        height: height ? height : 'auto',
        width: width ? width : 'auto',
        maxWidth: disableResponsive ? 'auto' : '100%',
        objectFit: fit ? imageFit[fit] : 'unset',
    });
});
